import { Action } from '../types/types';

export type DebugState = {
	debugEnabled: boolean,
	debugOverlaysEnabled: boolean,
	debugEchoCancellationEnabled: boolean,
	debugSocketCanDispatch: boolean,
	debugOpentok: boolean;
	debugKillServer: boolean;
	debugDisconnectProducer: boolean;
	debugLogIsoAlerts: boolean;
}

export const initialDebugState: DebugState = {
	debugEnabled: false,
	debugOverlaysEnabled: true,
	debugEchoCancellationEnabled: true,
	debugSocketCanDispatch: true,
	debugOpentok: false,
	debugKillServer: false,
	debugDisconnectProducer: false,
	debugLogIsoAlerts: false,
};

const actions: Map<string, Function> = new Map([
	['DEBUG_TOGGLE_DEBUG', (state: DebugState, action: Action): any => ({ ...state, debugEnabled: action.payload })],
	['DEBUG_TOGGLE_OVERLAYS', (state: DebugState, action: Action): any => ({ ...state, debugOverlaysEnabled: action.payload })],
	['DEBUG_TOGGLE_ECHO_CANCELLATION', (state: DebugState, action: Action): any => ({ ...state, debugEchoCancellationEnabled: action.payload })],
	['DEBUG_TOGGLE_SOCKET_DISPATCH', (state: DebugState, action: Action): any => ({ ...state, debugSocketCanDispatch: action.payload })],
	['DEBUG_OPENTOK_DISPATCH', (state: DebugState, action: Action): any => ({ ...state, debugOpentok: action.payload })],
	['DEBUG_TOGGLE_KILL_SERVER', (state: DebugState, action: Action): any => ({ ...state, debugKillServer: action.payload })],
	['DEBUG_TOGGLE_LOG_ISO_ALERTS', (state: DebugState, action: Action): any => ({ ...state, debugLogIsoAlerts: action.payload })],
]);

export function DebugReducer(state: DebugState = initialDebugState, action: Action) {
	return actions.get(action.type)?.(state, action) || state;
}
